import { z } from 'zod';

export const BackendErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
  requestId: z.string(),
});

export const OrganizationSchema = z.object({
  organizationId: z.string().uuid(),
  name: z.string().min(1),
  settings: z.record(z.unknown()),
  version: z.number().int(),
});

export const GetOrganizationResponseSchema = OrganizationSchema;

export const UserProfileSchema = z.object({
  userId: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string().nullable().optional(),
  avatarUrl: z.string().nullable().optional(),
  organization: z
    .object({
      organizationId: z.string().uuid(),
      name: z.string(),
      role: z.string(),
    })
    .optional(),
  nextNavigation: z
    .object({
      eligibleForNextShell: z.boolean(),
      orgEnabled: z.boolean(),
      previewEnabled: z.boolean(),
      globalEmergencyClassic: z.boolean(),
      intentReviewEnabled: z.boolean().optional(),
    })
    .optional(),
});

/**
 * Team Management Schemas
 */
export const TeamSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  name: z.string().min(1),
  description: z.string().nullable(),
  teamLeadId: z.string().uuid().nullable(),
  createdAt: z.string(),
  updatedAt: z.string().nullable(),
});

export const TeamListSchema = z.array(TeamSchema);

export type Organization = z.infer<typeof OrganizationSchema>;
export type UserProfile = z.infer<typeof UserProfileSchema>;
export type BackendError = z.infer<typeof BackendErrorSchema>;
export type Team = z.infer<typeof TeamSchema>;
